<script setup>
import { Panel } from '@dashhudson/dashing-ui';
</script>

<template>
  <div class="dash-h-full">
    <Panel title="Connected your Salesforce account" :collapsable="false">
      <p>Activation complete, reload Salesforce to access Dash Social - Community</p>
    </Panel>
  </div>
</template>
